import React, { useEffect, useState } from 'react';
import { getDespatchSummary } from 'services/lorry-loading-summary/despatchSummaryService';
import DespatchSummaryWidget from './DespatchSummaryWidget';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import LorryLoadingFilter from './LorryLoadingFilter';

const LorryLoadingSummaryDashboard = () => {
  const [despatchSummary, setDespatchSummary] = useState([]);
  const [stillageSummary, setStillageSummary] = useState([]);
  const [filter, setFilter] = useState({ deliveryDate: new Date() });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSummary(mapRQData(filter));
  }, []);

  const loadSummary = async rq => {
    if (!rq) return;
    setLoading(true);
    try {
      const { despatch, stillage } = await getDespatchSummary(
        rq.deliveryDate,
        rq.route
      );

      const greenKeys = [
        'framesRTL',
        'boxesRTL',
        'ancillsRTL',
        'weldedCillsRTL',
        'oneOffExtrasRTL'
      ];

      // Calculate RTL % and sort descending
      const sortByRtlPercent = data => {
        return [...data]
          .map(item => {
            const rtlSum = greenKeys.reduce(
              (sum, key) => sum + (item.stages[key] || 0),
              0
            );
            const totalSum = Object.values(item.totals || {}).reduce(
              (sum, v) => sum + (v || 0),
              0
            );
            const rtlPercent = totalSum > 0 ? (rtlSum / totalSum) * 100 : 0;
            return { ...item, rtlPercent };
          })
          .sort((a, b) => b.rtlPercent - a.rtlPercent);
      };

      // Apply sort to despatch
      const sortedDespatch = sortByRtlPercent(despatch);

      // Apply filter + sort to stillage
      const filteredAndSortedStillage = sortByRtlPercent(
        stillage.filter(item => {
          const totalSum = Object.values(item.totals || {}).reduce(
            (sum, v) => sum + (v || 0),
            0
          );
          return totalSum > 0; // Only keep items with data
        })
      );

      // setDespatchSummary(sortedDespatch);
      // setStillageSummary(filteredAndSortedStillage);

      setDespatchSummary(sortedDespatch);
      setStillageSummary(filteredAndSortedStillage);
    } catch (error) {
      console.error('Error loading summary:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    if (field === 'route') {
      setFilter({
        ...filter,
        [field]: value.map(x => x.name).join(',')
      });
    } else {
      setFilter({
        ...filter,
        [field]: value
      });
    }
  };

  const handleFilter = () => {
    const rq = mapRQData(filter);
    loadSummary(rq);
  };

  const mapRQData = data => {
    if (data) {
      let mapRq = { ...data };
      if (data?.deliveryDate && data?.deliveryDate instanceof Date) {
        mapRq.deliveryDate = data.deliveryDate.toISOString();
      }
      return mapRq;
    }
    return null;
  };

  return (
    <>
      <PageHeader title="Despatch Summary Dashboard" className="mb-3" />

      <Row className="mb-4">
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <LorryLoadingFilter
                formData={filter}
                handleChange={handleChange}
                handleSubmit={handleFilter}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <Spinner animation="border" role="status" variant="primary" />
          <span className="ms-2 fw-semibold">Loading summary...</span>
        </div>
      ) : (
        <Row className="g-4">
          <Col lg={6} md={12}>
            <Card className="shadow-sm rounded-4">
              <Card.Header className="bg-light fw-bold">
                Despatch Summary
              </Card.Header>
              <Card.Body className="bg-white">
                <Row className="g-4">
                  {despatchSummary.map((item, idx) => (
                    <Col md={6} key={idx}>
                      <DespatchSummaryWidget summary={item} />
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6} md={12}>
            <Card className="shadow-sm rounded-4">
              <Card.Header className="bg-light fw-bold">
                Stillage Summary
              </Card.Header>
              <Card.Body className="bg-white">
                <Row className="g-4">
                  {stillageSummary.map((item, idx) => (
                    <Col md={6} key={idx}>
                      <DespatchSummaryWidget summary={item} />
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default LorryLoadingSummaryDashboard;
